export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9722.54d9ed67.jpg";